import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext, ModalProvider } from '../../../context/ModalContext';
import AssignDispatcherModal from '../../../sections/dashboard/dispatch/AssignDispatcherModal';
import { HoverDropDown } from '../../DropDown/DropDown';
import HorizontalDot from '../../Icons/HorizontalDot';
import { Modal } from '../../Modal/Modal';

const IconContainer = () => {
  const modalContext = useContext(ModalContext);

  const createRackHandler = (e: any) => {
    modalContext?.displayModal(true);
  };
  return (
    <IconContainerWrapper
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <HoverDropDown className="options" label={<HorizontalDot />}>
        <DropDownContent
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            createRackHandler(e);
            e.stopPropagation();
          }}
        >
          Assign Dispatcher
        </DropDownContent>
      </HoverDropDown>
    </IconContainerWrapper>
  );
};

interface IAssignDispatcherComponent {
  children: string;
  noMenu?: boolean;
  tModalData: any;
}

const AssignDispatcherComponent: React.FC<IAssignDispatcherComponent> = ({
  children,
  noMenu,
  tModalData,
}) => {
  return (
    <ModalProvider>
      <Container>
        {children ?? <InActiveDiv>N/A</InActiveDiv>}
        {!noMenu && <IconContainer />}
      </Container>
      <Modal>
        <AssignDispatcherModal tdata={tModalData} />
      </Modal>
    </ModalProvider>
  );
};

export default AssignDispatcherComponent;

const DropDownContent = styled.div`
  display: flex;
  padding: 1rem;
  width: 150px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.brandBackdrop};
  }
`;

const Container = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;

const IconContainerWrapper = styled.div`
  display: flex;
  padding: 0.25rem 0.5rem;
`;

const InActiveDiv = styled.div`
  color: #a9a9a9;
  background-color: #f5f5f5;
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  width: fit-content;
  text-transform: capitalize;
  font-size: 0.875rem;
`;
